export default "__VITE_ASSET__CnRIF9NR__"